// i18n area 'tasks' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.lt-LT.meta.json.
import type { enUS } from './tasks'

export const ltLT: typeof enUS = {
  macrotasks: {
    title: 'Makrotask',
    subtitle: 'Sudėtinės operacijos — jas galima tęsti nuo nepavykusio žingsnio arba atšaukti',
    colType: 'Tipas',
    colTarget: 'Objektas',
    colPhase: 'Fazė',
    colSteps: 'Žingsniai',
    empty: 'Makrotask nėra',
    detail: 'Detalės',
    failedAt: 'nepavyko ties',
    resume: 'Bandyti dar kartą nuo nepavykusio žingsnio',
    abort: 'Nutraukti viską',
    cancel: 'Atšaukti',
    actionError: 'Veiksmas buvo atmestas'
  },
  tasks: {
    title: 'Task',
    searchPlaceholder: 'Ieškoti pagal tipą arba target',
    type: 'Tipas',
    target: 'Target',
    phaseLabel: 'Fazė',
    progress: 'Eiga',
    started: 'Pradėta',
    finished: 'Baigta',
    node: 'Mazgas',
    empty: 'Task nėra',
    loadError: 'Nepavyko įkelti task — ar TVirt backend pasiekiamas?',
    limboHint: "Mazgas '{node}' nepasiekiamas nuo {time} — task laiko savo target write lease tol, kol mazgas sugrįš arba bus patvirtinta, kad jis išjungtas",
    nodeAttested: 'Patvirtinta, kad mazgas išjungtas',
    phase: {
      queued: 'Eilėje',
      running: 'Vykdomas',
      succeeded: 'Įvykdytas',
      failed: 'Nepavyko',
      cancelled: 'Atšauktas',
      'failed-at-step': 'Nepavyko ties žingsniu',
      aborted: 'Nutrauktas'
    },
    dropdown: {
      tooltip: 'Vykdomi task',
      title: 'Vykdomi task',
      empty: 'Vykdomų task nėra',
      viewAll: 'Peržiūrėti visus task'
    },
    detail: {
      open: 'Detalės',
      scope: 'Scope',
      message: 'Pranešimas',
      params: 'Parametrai',
      result: 'Rezultatas',
      errorTitle: 'Klaida',
      steps: 'Žingsniai',
      failedAt: 'nepavyko ties',
      superseded: 'nebeaktualus',

      // Standartinis dialogas (round #156): vaiko vieta tėvo plane,
      // pats tėvas (atveriamas vietoje) ir kaltas žingsnis.
      step: 'Žingsnis',
      parent: 'Tėvinis task',
      failedStep: 'Nepavykęs žingsnis',
      log: 'Žurnalas',
      logEmpty: 'Žurnale kol kas nėra įrašų',
      close: 'Uždaryti'
    },
    actions: {
      cancel: 'Atšaukti',
      resume: 'Bandyti dar kartą nuo nepavykusio žingsnio',
      abort: 'Nutraukti viską (atsukti atliktus žingsnius)',
      refused: 'Veiksmas buvo atmestas'
    }
  },
  events: {
    loadError: 'Nepavyko įkelti žurnalo — ar TVirt vidinė sistema pasiekiama?',
    title: 'Įvykiai',
    subtitle: 'Klasterio istorinė atmintis: įvykę faktai, nuo naujausių',
    filterSeverity: 'Svarba',
    filterCategory: 'Kategorija',
    filterAll: 'Visos',
    searchLabel: 'Ieškoti',
    searchPlaceholder: 'Ieškoti visame žurnale',
    subjectFilter: '{subject} įvykiai — rodyti visus',
    colAt: 'Kada',
    colSeverity: 'Svarba',
    colType: 'Tipas',
    colSubject: 'Objektas',
    colActor: 'Kas',
    colNode: 'Node',
    colMessage: 'Pranešimas',
    empty: 'Įvykių nėra',
    loadMore: 'Įkelti daugiau',
    actorSystem: 'sistema',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Įvykio ID',
    taskCollectedHint: 'Task saugomas trumpiau: kai jis surinktas, nuoroda nebeatsako',
    severity: {
      info: 'Informacija',
      warning: 'Įspėjimas',
      error: 'Klaida',
      critical: 'Kritinis'
    },
    category: {
      lifecycle: 'Gyvavimo ciklas',
      config: 'Konfigūracija',
      availability: 'Pasiekiamumas',
      security: 'Sauga'
    },
    type: {
      haNetsvcFailedOver: 'Tinklo paslaugos failover',
      haNetsvcNoCandidate: 'Tinklo paslauga be kandidato mazgo',
      haNetsvcReaped: 'Vietinis egzempliorius nupjautas grįžus',
      netsvcFloatipMoved: 'Plaukiojantis IP perkeltas kitam laikytojui',
      netsvcFloatipNoHolder: 'Plaukiojantis IP be sveiko taikinio',
      haAppFailedOver: 'App egzemplioriaus failover',
      haAppNoCandidate: 'App egzempliorius be kandidato mazgo',
      haAppStorageLocalSkip: 'App egzempliorius neperkeltas: nuolatiniai duomenys lokalūs mirusiame mazge',
      haAppReaped: 'App egzemplioriaus vietinis podas nupjautas grįžus'
    }
  },
  audit: {
    loadError: 'Nepavyko įkelti audito registro — ar TVirt vidinė sistema pasiekiama?',
    title: 'Auditas',
    subtitle: 'Kas ką padarė, kada ir su kuriuo objektu — bandyti veiksmai, įskaitant atmestus',
    filterOutcome: 'Baigtis',
    filterAll: 'Visos',
    filterSudo: 'Tik pakelto lygio veiksmai',
    colAt: 'Kada',
    colActor: 'Kas',
    colAction: 'Veiksmas',
    colTarget: 'Objektas',
    colOutcome: 'Baigtis',
    colNode: 'Node',
    empty: 'Įrašytų veiksmų nėra',
    loadMore: 'Įkelti daugiau',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Maršrutas',
    detailProblem: 'Priežastis',
    detailTask: 'Task',
    detailClientIp: 'Iš kur',
    detailId: 'Įrašo ID',
    detailSession: 'Seansas',
    taskHint: 'Priimto veiksmo baigtis gyvena įvykių žurnale, po tuo pačiu task id',
    outcome: {
      succeeded: 'Pavyko',
      accepted: 'Priimta',
      denied: 'Neleista',
      rejected: 'Atmesta',
      failed: 'Nepavyko'
    }
  },
  notifications: {
    loadError: 'Nepavyko įkelti pranešimų — ar TVirt vidinė sistema pasiekiama?',
    actionError: 'Veiksmas buvo atmestas',
    title: 'Pranešimai',
    subtitle: 'Paskirties vietos, į kurias žurnalo faktai palieka klasterį',
    rulesTitle: 'Taisyklės',
    rulesSubtitle: 'Kurie faktai išeina ir kur',
    deliveriesTitle: 'Pristatymai',
    deliveriesSubtitle: 'Kiekvieno pranešimo rezultatas su priežastimi, kai nepavyksta',
    colName: 'Pavadinimas',
    colKind: 'Tipas',
    colWhere: 'Kur',
    colScope: 'Scope',
    colSeverity: 'Svarba',
    colMatch: 'Filtras',
    colTargets: 'Paskirtis',
    colAt: 'Kada',
    colState: 'Būsena',
    colEvent: 'Įvykis',
    colAttempts: 'Bandymai',
    colOutcome: 'Rezultatas',
    empty: 'Nėra eilučių',
    matchAll: 'visi faktai',
    test: 'Išbandyti',
    testOk: 'Bandomasis pranešimas pristatytas į {target}',
    testFailed: 'Bandymas į {target} nepavyko: {reason}',
    retry: 'Grąžinti į eilę',
    retried: 'Pristatymas grąžintas į eilę',
    grouped: 'ir dar {count} pasikartojimų',
    state: {
      failed: 'Nepavyko',
      pending: 'Eilėje',
      sending: 'Siunčiama',
      sent: 'Išsiųsta'
    },
    tabTargets: 'Paskirtys',
    tabRules: 'Taisyklės',
    tabDeliveries: 'Pristatymai',
    targetCreateTitle: 'Nauja paskirtis',
    ruleCreateTitle: 'Nauja taisyklė',
    nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai; unikalu kiekvienoje srityje',
    kindImmutableHint: 'Nekintama: pakeisti tipą reiškia sukurti kitą paskirtį',
    kindSmtp: 'Paštas (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Būsena',
    enabledOn: 'Aktyvi',
    enabledOff: 'Sustabdyta',
    smtpHost: 'SMTP serveris',
    smtpPort: 'Prievadas',
    smtpPortHint: 'Paprastai: 25 be TLS, 587 su starttls, 465 su tls',
    smtpSecurity: 'Sauga',
    smtpFrom: 'Siuntėjas',
    smtpTo: 'Gavėjai',
    smtpToHint: 'Vienas ar daugiau adresų, atskirtų kableliais',
    webhookUrl: 'URL',
    payload: 'Turinys',
    payloadHint: 'Su minimal įvykio pranešimas ir duomenys neišeina iš klasterio',
    credential: 'Kredencialas',
    credentialNone: 'Nėra',
    credentialHintSmtp: 'Perdavimo paskyra iš raktų saugyklos; nėra reiškia anoniminį SMTP',
    credentialHintWebhook: 'Pasirašymo paslaptis iš raktų saugyklos; be pasirašymo kiekvienas, žinantis URL, gali apsimesti klasteriu',
    minSeverityHint: 'Riba, ne rinkinys: nuo šio sunkumo ir aukščiau',
    categories: 'Kategorijos',
    categoriesHint: 'Tuščia = visos',
    types: 'Įvykių tipai',
    typesHint: 'Atskirti kableliais; tuščia = visi. Nežinomas tipas atmetamas',
    targetsHint: 'Bent viena; jos turi būti taisyklės srityje arba jos pirmtake',
    recursiveOn: 'Taip pat vaikinės sritys',
    recursiveOff: 'Tik ši sritis',
    recursiveHint: 'Ištekliai gyvena lapuose: be vaikų taisyklė šaknyje praneša beveik nieko',
    repeatWindow: 'Grupavimo langas (s)',
    repeatWindowHint: 'Lange pakartojimai pašto nesiunčia: jie skaičiuojami prie pirmojo. 0 išjungia',
    targetInUseError: 'Paskirtį {name} vis dar naudoja taisyklė'
  }
}
